var netwerkInfoDivs = document.querySelectorAll(".netwerk-info");

var loca = []; // Define the array outside the forEach loop

netwerkInfoDivs.forEach(function (div) {
  var lat = parseFloat(div.getAttribute("data-lat"));
  var lng = parseFloat(div.getAttribute("data-lng"));

  var name = div.getAttribute("data-name");
  var body = div.getAttribute("data-body");
  var address = div.getAttribute("data-address");
  var email = div.getAttribute("data-email");
  var phone = div.getAttribute("data-phone");
  var url = div.getAttribute("data-url");
  var tags = "";
  if (div.getAttribute("data-tags") != "") {
    tags = JSON.parse(div.getAttribute("data-tags"));
  }
  else {
    // tags = "";
  }

  loca.push({
    lat: lat,
    lng: lng,
    name: name,
    body: body,
    address: address,
    email: email,
    phone: phone,
    url: url,
    tags: tags,
  });
});

// ------------------------- NETWERK MAP ---------------------------------
function netwerkInitMap() {

  var location = loca;

  var mapOptions = {
    zoom: 12,
    draggable: true,
    scrollwheel: true,
    mapTypeControl: false,
    zoomControl: true,
    streetViewControl: false,
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
  };

  var map = new google.maps.Map(
    document.getElementById("netwerk-map-canvas"),
    mapOptions
  );

  var bounds = new google.maps.LatLngBounds();

  var currentSelectedMarker = null;
  var initialFillColor = "white";
  var initialTextColor = "black";
  var markerArray = [];

  function getMarkerIcon(fillColor, textColor, newIndex) {
    var svgCodeWithColor = `
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="26" stroke="black" stroke-width="2" fill="${fillColor}" />
      <text class="font-degularText" x="50%" y="52%" text-anchor="middle" alignment-baseline="middle" fill="${textColor}" font-size="18px" style="font-family: 'degular-text', sans-serif">
        ${newIndex}
      </text>
    </svg>
  `;

    return {
      url: "data:image/svg+xml;charset=UTF-8;base64," + btoa(svgCodeWithColor),
    };
  }

  var tagsArray = "";
  location.forEach(function (location, index) {
    var newIndex = 1 + index;
    if (newIndex < 10) {
      newIndex = "0" + newIndex;
    }

    var circleFillColor = initialFillColor;
    var textColor = initialTextColor;

    if (newIndex === "01") {
      circleFillColor = "black";
      textColor = "white";
    }

    var markerIcon = getMarkerIcon(circleFillColor, textColor, newIndex);


    var marker = new google.maps.Marker({
      position: location,
      map: map,
      // title: "Hello World!",
      icon: markerIcon,
    });

    markerArray.push(marker);

    bounds.extend(location); // Extend the bounds with each location

    currentSelectedMarker = markerArray[0];
    currentSelectedMarker.index = "01";

    marker.addListener("click", function () {
      var count = newIndex;

      document.getElementById("partner-name").innerHTML =
        count + "-  " + location.name;
      document.getElementById("partner-body").innerHTML = location.body;
      document.getElementById("partner-address").innerHTML = location.address;

      document.getElementById("partner-email").innerHTML = location.email;
      var partnerEmailLink = document.getElementById("partner-email-link");
      partnerEmailLink.href = "mailto:" + location.email;

      document.getElementById("partner-phone").innerHTML = location.phone;

      var partnerWebsiteButton = document.getElementById(
        "partner-website-button"
      );
      partnerWebsiteButton.onclick = function () {
        window.location.href = location.url;
      };

      tagsArray = location.tags;

      if (tagsArray == "") {
        const tagContainer = document.getElementById("netwerk-tags");
        const existingTagDiv = tagContainer.querySelector(".tag");
        if (existingTagDiv) {
          tagContainer.removeChild(existingTagDiv); // Remove the existing tag div
        }
        tagContainer.innerHTML = ""; // Clear the content of the container

        const emptyDiv = document.createElement("div");
        tagContainer.appendChild(emptyDiv); // Append the empty div element

      } else {
        const tagContainer = document.getElementById("netwerk-tags");
        tagContainer.innerHTML = ""; // Clear the content of the container
        tagsArray.forEach((tag) => {
          const tagElement = document.createElement("div");
          tagElement.className = "tag inline-block pt-px pb-1 px-2 rounded-full border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative cursor-pointer";
          tagElement.innerHTML = `<span class="text-sm font-degularText uppercase">${tag}</span>`;

          tagContainer.appendChild(tagElement); // Append the new tag element
        });
        tagsArray = "";
      }


      if (currentSelectedMarker) {
        var resetFillColor = initialFillColor;
        var resetTextColor = initialTextColor;

        currentSelectedMarker.setIcon(getMarkerIcon(resetFillColor, resetTextColor, currentSelectedMarker.index));
      }

      marker.setIcon(getMarkerIcon("black", "white", newIndex));

      currentSelectedMarker = marker;
      currentSelectedMarker.index = newIndex;

    });
  });

  // Fit the map to the bounds
  map.fitBounds(bounds);
}

// document.addEventListener("DOMContentLoaded", netwerkInitMap);
document.addEventListener("DOMContentLoaded", function () {
  var netwerkMapCanvas = document.getElementById("netwerk-map-canvas");

  if (netwerkMapCanvas) {
    netwerkInitMap();
  }
});

// ------------------------- HOME MAP ---------------------------------

function homeInitMap() {

  var location = loca;

  var mapOptions = {
    zoom: 12,
    draggable: true,
    scrollwheel: true,
    mapTypeControl: false,
    zoomControl: true,
    streetViewControl: false,
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
  };

  var map = new google.maps.Map(
    document.getElementById("home-map-canvas"),
    mapOptions
  );

  var bounds = new google.maps.LatLngBounds();

  var currentSelectedMarker = null;
  var initialFillColor = "white";
  var initialTextColor = "black";
  var markerArray = [];

  function getMarkerIcon(fillColor, textColor, newIndex) {
    var svgCodeWithColor = `
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="26" stroke="black" stroke-width="2" fill="${fillColor}" />
      <text class="font-degularText" x="50%" y="52%" text-anchor="middle" alignment-baseline="middle" fill="${textColor}" font-size="18px" style="font-family: 'degular-text', sans-serif">
        ${newIndex}
      </text>
    </svg>
  `;

    return {
      url: "data:image/svg+xml;charset=UTF-8;base64," + btoa(svgCodeWithColor),
    };
  }

  var tagsArray = "";
  location.forEach(function (location, index) {
    var newIndex = 1 + index;
    if (newIndex < 10) {
      newIndex = "0" + newIndex;
    }

    var circleFillColor = initialFillColor;
    var textColor = initialTextColor;

    if (newIndex === "01") {
      circleFillColor = "black";
      textColor = "white";
    }

    var markerIcon = getMarkerIcon(circleFillColor, textColor, newIndex);


    var marker = new google.maps.Marker({
      position: location,
      map: map,
      // title: "Hello World!",
      icon: markerIcon,
    });

    markerArray.push(marker);

    bounds.extend(location); // Extend the bounds with each location

    currentSelectedMarker = markerArray[0];
    currentSelectedMarker.index = "01";


    marker.addListener("click", function () {
      var count = newIndex;

      document.getElementById("partner-name").innerHTML =
        count + "-  " + location.name;
      document.getElementById("partner-body").innerHTML = location.body;
      document.getElementById("partner-address").innerHTML = location.address;

      document.getElementById("partner-email").innerHTML = location.email;
      var partnerEmailLink = document.getElementById("partner-email-link");
      partnerEmailLink.href = "mailto:" + location.email;

      document.getElementById("partner-phone").innerHTML = location.phone;

      var partnerWebsiteButton = document.getElementById(
        "partner-website-button"
      );
      partnerWebsiteButton.onclick = function () {
        window.location.href = location.url;
      };

      tagsArray = location.tags;

      if (tagsArray == "") {
        const tagContainer = document.getElementById("netwerk-tags");
        const existingTagDiv = tagContainer.querySelector(".tag");
        if (existingTagDiv) {
          tagContainer.removeChild(existingTagDiv); // Remove the existing tag div
        }
        tagContainer.innerHTML = ""; // Clear the content of the container

        const emptyDiv = document.createElement("div");
        tagContainer.appendChild(emptyDiv); // Append the empty div element

      } else {
        const tagContainer = document.getElementById("netwerk-tags");
        tagContainer.innerHTML = ""; // Clear the content of the container
        tagsArray.forEach((tag) => {
          const tagElement = document.createElement("div");
          tagElement.className = "tag inline-block pt-px pb-1 px-2 rounded-full border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative cursor-pointer";
          tagElement.innerHTML = `<span class="text-sm font-degularText uppercase">${tag}</span>`;

          tagContainer.appendChild(tagElement); // Append the new tag element
        });
        tagsArray = "";
      }

      if (currentSelectedMarker) {
        var resetFillColor = initialFillColor;
        var resetTextColor = initialTextColor;

        currentSelectedMarker.setIcon(getMarkerIcon(resetFillColor, resetTextColor, currentSelectedMarker.index));
      }

      marker.setIcon(getMarkerIcon("black", "white", newIndex));

      currentSelectedMarker = marker;
      currentSelectedMarker.index = newIndex;

    });
  });

  // Fit the map to the bounds
  map.fitBounds(bounds);
}

// document.addEventListener("DOMContentLoaded", homeInitMap);
document.addEventListener("DOMContentLoaded", function () {
  var homeMapCanvas = document.getElementById("home-map-canvas");

  if (homeMapCanvas) {
    homeInitMap();
  }
});
